import { OverlayModule } from '@angular/cdk/overlay';
import { Component, inject } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AutofocusDirective } from '../../directives/sia-autofocus.directive';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';
@Component({
  selector: 'sia-error-dialog',
  templateUrl: `sia-error-dialog.html`,
  styleUrls: ['sia-error-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIconModule,
    SiaTranslatePipe,
    MatIconButton,
    OverlayModule,
    AutofocusDirective,
  ],
})
export class SiaErrorDialog {
  dialogRef = inject<MatDialogRef<SiaErrorDialog>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  pageData: any;
  emailString: string | undefined;

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.updateSize('min(95% , 600px)');
    this.emailString = `mailto:supporto@siainformatica.com?Subject=Report Errore ${new Date().toISOString()}&body=Codice di errore: ${this.data.title}\n${this.data.requestUrl}\n${this.data.message}`;
  }

  close() {
    this.dialogRef.close();
  }

  async copyMessageToClipboard() {
    const textToCopy =
      this.data.title + '\n' + this.data.requestUrl + '\n' + this.data.message;

    try {
      // Prova prima con la Clipboard API moderna
      await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
      // Fallback per mobile o browser che non supportano clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err2) {
        // Ignora errori
      } finally {
        textArea.remove();
      }
    }
  }

  async sendEmail() {
    throw new Error('Method not implemented.');
  }
}
